/* Extra upward movement for Sayless hero text while the hero scrolls away. */
(() => {
  if (window.__saylessHeroScrollText) return;
  window.__saylessHeroScrollText = true;

  const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
  const smallScreen = window.matchMedia("(max-width: 749px)");
  let frame = 0;

  const update = () => {
    frame = 0;

    document
      .querySelectorAll('sayless-hero[id^="SaylessHero-"]')
      .forEach((hero) => {
        hero.setAttribute("data-sl-scroll-text", "");

        if (reducedMotion.matches) {
          hero.style.setProperty("--sl-hero-scroll-offset", "0px");
          return;
        }

        const rect = hero.getBoundingClientRect();
        const scrolled = Math.max(
          0,
          Math.min(1, -rect.top / Math.max(rect.height, 1)),
        );
        const progress = Math.max(0, Math.min(1, (scrolled - 0.25) / 0.4));
        const distance = smallScreen.matches ? 36 : 70;
        hero.style.setProperty(
          "--sl-hero-scroll-offset",
          `${(-distance * progress).toFixed(2)}px`,
        );
      });
  };

  const schedule = () => {
    if (!frame) frame = requestAnimationFrame(update);
  };

  window.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  document.addEventListener("shopify:section:load", schedule);
  reducedMotion.addEventListener("change", schedule);
  smallScreen.addEventListener("change", schedule);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", schedule, { once: true });
  } else {
    schedule();
  }
})();
